import PropTypes from 'prop-types';

export const CONTENT_TYPES = {
  'icon-check': 'icon-check',
  'icon-minus': 'icon-minus',
  'icon-not-available': 'icon-not-available',
  text: 'text',
};

export const PLAN_ROW_ITEM_PROP_TYPES = {
  contentType: PropTypes.oneOf(Object.values(CONTENT_TYPES)),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isCompact: PropTypes.bool,
  loading: PropTypes.bool,
  hover: PropTypes.bool,
};
